import React from "react";
import "./SocialLogIn.css";

function SocialLogIn() {
  return (
    <>
      <div className="total_log">
        <div className="log_text">
          <p>Or sign in with</p>
        </div>
      </div>
    </>
  );
}

export default SocialLogIn;
